module.exports = __webpack_public_path__ + "img/about-4.01f28d64.png";